// services/QuestionTypeService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getQuestionTypes(params = {}) {
    return api.get(ENDPOINTS.QUESTION_TYPES.BASE, { params });
}
export function createQuestionType(payload) {
    return api.post(ENDPOINTS.QUESTION_TYPES.BASE, payload);
}
export function updateQuestionType(id, payload) {
    return api.patch(ENDPOINTS.QUESTION_TYPES.BY_ID(id), payload);
}
export function deleteQuestionType(id) {
    return api.delete(ENDPOINTS.QUESTION_TYPES.BY_ID(id));
}
export function restoreQuestionType(id) {
    return api.post(`${ENDPOINTS.QUESTION_TYPES.BY_ID(id)}/restore`);
}
